module.exports = __webpack_public_path__ + "1b0f3b2643cfbf7e160b6219516b0c01.jpg";


//////////////////
// WEBPACK FOOTER
// ./design/photos/objekte/Ruoff_091125_0156_V_w.jpg
// module id = 363
// module chunks = 0